var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.spacing,style:({backgroundColor:_vm.options.color, height:_vm.options.height, width:_vm.options.width})})}
var staticRenderFns = []

export { render, staticRenderFns }